import { render, staticRenderFns } from "./set-reporting-interval-modal.vue?vue&type=template&id=835dbf8a&"
import script from "./set-reporting-interval-modal.vue?vue&type=script&lang=js&"
export * from "./set-reporting-interval-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports